module.exports = __webpack_public_path__ + "media/images/datepicker_next-af8e7bba556a93fb4884fb9368bafdc3.svg";